module.exports = __webpack_public_path__ + "img/phone.c840b18b.svg";